import React from 'react';
import { FieldChangeGrid } from '@pages/admin/audit-log/change-grid';
import AuditEnumValues from '@pages/admin/audit-log/definitions/enums';
import { getFieldChangeItems, getProcessedFieldChangeItems } from '@pages/admin/audit-log/service';
import { useTranslation } from '@hooks/index';

interface RecordProps {
    PanelId: number;
    PanelName: string;
    DisplayOrder?: number;
}

const RiskDashboardSetupGrid = ({ oldRecord, newRecord, oldItem, newItem, record }: any) => {
    const { t } = useTranslation('auditLog', { keyPrefix: 'riskDashboard.panels' });
    const formatPanels = (recordData: unknown) => {
        if (!recordData) {
            return null;
        }
        return `${recordData.DisplayOrder} - ${t(AuditEnumValues.riskDashboardPanel[recordData.PanelId])}`;
    };

    const arrayOfObjectsV2: any = {
        Panels: {
            valueResolver: formatPanels,
        },
    };

    const refactorRecord = (rec: RecordProps) => {
        return {
            ...rec,
        } as Record<string, unknown>;
    };

    const refactoredOldRecord = refactorRecord(oldRecord as RecordProps);
    const refactoredNewRecord = refactorRecord(newRecord as RecordProps);

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({ oldRecord, newRecord, oldItem, newItem, field, arrayOfObjectsV2 }),
    );

    return <FieldChangeGrid items={items} />;
};

export { RiskDashboardSetupGrid };
